module.exports = __webpack_public_path__ + "img/photo_260010873_1.aeece99b.jpg";